import React, { Component } from 'react';
// import {Doughnut} from 'react-chartjs-2';

import functions from '../../../../functions/Estadisticas/getData';

import '../estaHome.css';
import './conversa.css';

class Conversa extends Component{

    constructor(){
        super();
        this.state = {
            cantidadInte: 0
        };

        functions.GetDataInteracciones().then((datos) => {
            this.setState({
                cantidadInte: datos,
            });
        });
    }


    render(){
        return(
            <div className='col s12 xl4'>
                <div className='card-panel empresaCard conversaCard'>
                    <p>Interacciones</p>
                    <h5>{this.state.cantidadInte}</h5>
                    <i className='large material-icons chatLogo'>chat_bubble</i>
                </div>
            </div>
        );
    }
}

export default Conversa;